import { Button, Stack, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import {} from 'react-router'
import { useMutation } from 'urql'
import { graphql } from '../../gql'
import { OrderContextProviderQuery, UpdateRfqInput } from '../../gql/graphql'

const updateRfqMutation = graphql(`
  mutation UpdateRfqForm($id: Int!, $input: UpdateRfqInput!) {
    UpdateRfq(id: $id, input: $input) {
      id
    }
  }
`)
type TProps = {
  rfq: NonNullable<OrderContextProviderQuery['Rfq']>
  onCancel: () => void
  onUpdated: () => void
}
export function EditRfqForm(props: TProps) {
  const { rfq, onUpdated, onCancel } = props
  const [updateRfqResult, updateRfq] = useMutation(updateRfqMutation)

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    if (updateRfqResult.fetching) return
    const input: UpdateRfqInput = {
      name: data.name.trim() === '' ? null : data.name,
      dateReceived: data.dateReceived?.toISOString() || null,
    }
    const resp = await updateRfq({
      id: rfq.id,
      input,
    })
    if (!resp.error) {
      onUpdated()
    }
  }

  interface IFormInput {
    name: string
    dateReceived: Dayjs | undefined
  }

  const { handleSubmit, control, setValue } = useForm<IFormInput>({
    defaultValues: {
      name: rfq.name || '',
      dateReceived: rfq.dateReceived ? dayjs(rfq.dateReceived) : dayjs(),
    },
    mode: 'onBlur',
    disabled: updateRfqResult.fetching,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} onReset={onCancel}>
      <Stack sx={{ ml: 0, mt: 2 }} spacing={4} justifyContent="stretch">
        <Controller
          name="name"
          control={control}
          render={({ field, fieldState }) => {
            return (
              <TextField
                label="RFQ Name"
                {...field}
                error={!!fieldState.error}
                placeholder={`"Common area rugs" or "King double suite mirrors"...`}
                helperText={fieldState.error?.message || 'A name for the RFQ'}
              />
            )
          }}
        />
        <Controller
          name="dateReceived"
          control={control}
          render={({ field, fieldState }) => {
            return (
              <DatePicker
                label="Date Received"
                {...field}
                disableFuture
                slotProps={{
                  textField: {
                    error: !!fieldState.error,
                    helperText: fieldState.error?.message || undefined,
                  },
                  field: {
                    clearable: true,
                  },
                }}
              />
            )
          }}
        />
        <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
          <Button type="reset" variant="outlined" color="primary">
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="secondary" disabled={updateRfqResult.fetching}>
            Submit
          </Button>
        </Stack>
      </Stack>
    </form>
  )
}
